module.exports = __webpack_public_path__ + "9779d9a1/img/SOURCERY_poweredby_web.9819842b.png";